export default "__VITE_ASSET__DOIJZbIK__"